import * as R from 'ramda'

import { type KPIScoreLimit, Score } from 'components/KPICard'
import { isNilOrEmpty } from 'utils/ramda'

import { parseMetric } from './KPICard.formatter'

export const resolveCubeKPIPercentage = (
  data: any,
  metricMeasure: string,
  totalMeasure: string
) => {
  if (!R.isNil(data)) {
    const result = R.head(data.tablePivot())
    const metric = R.pathOr(0, [metricMeasure], result)
    const total = R.pathOr(0, [totalMeasure], result)

    if (R.lte(total, 0)) {
      return null // explictly return empty if total is 0 - implies we don't have data for this range
    }

    return R.multiply(R.divide(metric, total), 100)
  }
}

export const resolveCubeListKPIResults = (data: any, queryName: string[]) => {
  const counts: number[] = []
  if (!isNilOrEmpty(queryName) && !R.isNil(data)) {
    for (const item of queryName) {
      const results = data.tablePivot().map((data: any) => data[item]) ?? []
      counts.push(parseMetric(results))
    }
  }
  return counts
}

export const resolveCubeKPIResults = (data: any, queryName: string) => {
  if (!R.isNil(data)) {
    const results = data.tablePivot().map((item: object) => item[queryName])
    return parseMetric(results)
  }
}

export const resolveKPIScore = (
  value: number | null | undefined,
  scoresArr: KPIScoreLimit[]
) => {
  if (typeof value === 'number') {
    const kpiScore = R.find(
      (score) =>
        !R.isNil(score.min)
          ? R.gte(value, score.min)
          : !R.isNil(score.max)
          ? R.lte(value, score.max)
          : false,
      scoresArr
    )
    return R.pathOr(0, ['score'], kpiScore)
  }

  // empty score if value is undefined
  return Score.None
}

export const resolveTotalRecords = (data: any, metricMeasure: string) => {
  if (!R.isNil(data)) {
    const result = R.head(data.tablePivot())
    return R.pathOr(0, [metricMeasure], result)
  } else {
    return 0
  }
}
